import type { StaffNavIcon } from '../clinic/nav';

const PATHS: Record<StaffNavIcon, string> = {
  calendar: 'M7 3v3M17 3v3M4.5 8h15M6 5.5h12A1.5 1.5 0 0 1 19.5 7v12A1.5 1.5 0 0 1 18 20.5H6A1.5 1.5 0 0 1 4.5 19V7A1.5 1.5 0 0 1 6 5.5zM8 12h3v3H8z',
  patients:
    'M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM15.5 8.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM4 19.5c.4-3 2.6-5 5-5s4.6 2 5 5M14 14.8c1.6-.5 3.4.1 4.6 2.2',
  chart: 'M5 19.5V6.5M5 19.5h14M8.5 15V11M12 15V8M15.5 15v-2.5',
  service: 'M12 4.5 13.8 9l4.7.4-3.6 3.1 1.1 4.6L12 14.8 8 17.1l1.1-4.6L5.5 9.4 10.2 9z',
  orders: 'M7 6.5h10M7 12h10M7 17.5h6',
  checkout: 'M6 7.5h14l-1.4 8.2A1.5 1.5 0 0 1 17.1 17H9.2A1.5 1.5 0 0 1 7.7 15.7L5.4 5.5H3.5M9 20.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5zM16.5 20.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5z',
  business: 'M5 20.5V8.5L12 4l7 4.5v12M9 20.5v-6h6v6',
  admin: 'M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM6.2 18.5c.8-2.2 2.9-3.5 5.8-3.5s5 1.3 5.8 3.5',
  provider: 'M12 12.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM6 19c.7-2.4 3-4 6-4s5.3 1.6 6 4M16.5 7.5 18 6M18 6l1.5 1.5M18 6v3',
  oversight: 'M12 5.5 4.5 9.5 12 13.5l7.5-4zM4.5 13.5 12 17.5l7.5-4',
  profile: 'M12 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM6.5 19c.7-2.5 2.9-4 5.5-4s4.8 1.5 5.5 4',
  support: 'M12 20.5a8.5 8.5 0 1 0-7.2-4M9.5 10.2c.4-1.3 1.5-2 2.6-2s2.3.8 2.3 2.1c0 1.5-1.4 2-2.3 2.6V14M12 17h.01',
};

export function navIcon(name: StaffNavIcon): SVGSVGElement {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('class', 'nav-icon');
  svg.setAttribute('aria-hidden', 'true');
  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  path.setAttribute('d', PATHS[name]);
  path.setAttribute('fill', 'none');
  path.setAttribute('stroke', 'currentColor');
  path.setAttribute('stroke-width', '1.6');
  path.setAttribute('stroke-linecap', 'round');
  path.setAttribute('stroke-linejoin', 'round');
  svg.append(path);
  return svg;
}
